/**
 * Shared shell chrome for Run + Studio pages — Aurora flat, dense rendering
 * (pilote-maurice `wiki/design/os-aurora-migration.md` § 3): opaque `--card`
 * surfaces with a 1 px `--border` line and a 16 px radius; no gradient, no
 * halo, no transparency, no shadow.
 */
export const shellPageBackgroundClassName = 'bg-background'

export const shellSurfaceClassName =
  'overflow-hidden rounded-card border border-border bg-card'

export const shellPageContentClassName =
  'mx-auto flex min-h-full w-full max-w-7xl flex-col gap-6 p-6 lg:p-8'

export const shellHeroBorderClassName = 'border-b border-border'

export const shellInsetCardClassName =
  'rounded-card border border-border bg-card p-4'

// Secondary text sits on this panel: it stays on --card (night
// --muted-foreground reaches only 4.40:1 on --card-raised).
export const shellMutedPanelClassName =
  'rounded-card border border-dashed border-border bg-card p-4'

/** Shared nav active state (Run + Studio): `--primary-soft`, no left border accent. */
export const shellNavActiveClassName =
  'bg-primary-soft font-semibold text-foreground'
